import { motion } from "framer-motion";
import { useLead, useSettings } from "../lib/store";
import { track } from "../lib/track";
import { WhatsAppIcon } from "./icons";

export default function FloatingWhatsApp() {
  const { openLead } = useLead();
  const { settings } = useSettings();

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
      onClick={() => {
        track("click_whatsapp", { source: "floating_button" });
        openLead();
      }}
      data-testid="floating-whatsapp-trigger"
      className="group fixed bottom-[92px] right-4 z-40 flex items-center gap-3 md:bottom-6 md:right-6"
      aria-label="Konsultasi via WhatsApp"
    >
      <span className="pointer-events-none hidden rounded-full bg-white px-4 py-2 text-xs font-semibold text-charcoal opacity-0 shadow-elevated transition-all duration-300 group-hover:opacity-100 md:block">
        {settings?.whatsapp_display || "Konsultasi WhatsApp"}
      </span>
      <span className="relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.7)]">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <WhatsAppIcon className="relative h-7 w-7" />
      </span>
    </motion.button>
  );
}
